export const texts = {
  de: {
    noData: 'Keine Daten verfügbar',
    company: 'Unternehmen',
    cdsPrice: 'CDS-Preis',
    asOf: 'Stand:',
    source: 'Quelle: CMA'
  },
  en: {
    noData: 'No data available',
    company: 'Company',
    cdsPrice: 'CDS Price',
    asOf: 'As at:',
    source: 'Source: CMA'
  }
}
